import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Order } from '@app/core/business/order/order';
import { OrderStatus } from '@app/core/business/order/order-status';
import { OrderService } from '@app/core/business/order/order.service';
import { AuthenticationService } from '@app/core/business/user/authentication.service';
import { User } from '@app/core/business/user/user';
import { UserService } from '@app/core/business/user/user.service';
import { Context, ContextService, FullContext } from '@app/core/service/context.service';
import { TranslationService } from '@app/core/service/translation.service';
import { ModalFactoryService } from '@app/core/ui/modal/modal-factory.service';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
//import * as moment from 'moment';
import * as moment from 'moment-timezone';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject, Observable, interval, of } from 'rxjs';
import { finalize, repeatWhen, switchMap, takeWhile, tap } from 'rxjs/operators';
import { ContactService } from '@app/core/business/contact/contact.service';
import { ToastrService } from 'ngx-toastr';
import { SearchService } from '../product/search.service';
import { CustomerService } from '@app/core/business/customer/customer.service';
import { Company } from '@app/core/business/company/company';
import { CompanyService } from '@app/core/business/company/company.service';
import { FavoriteService } from '@app/core/business/product/favorite.service';
import { BusinessContact } from '@app/core/business/customer/business-contact';
import { SortingService } from '@app/core/service/sorting.service';
import { Franco } from '@app/core/business/franco/franco';
import { FrancoService } from '@app/core/business/franco/franco.service';
import { DialogService } from '@app/core/service/dialog.service';
import { DialogFrancoComponent, DialogFrancoData } from '../dialog/dialog-franco/dialog-franco.component';
import { OfferStateService } from '../offer/offer-state.service';
import { ElasticSearchService } from '@app/core/business/elastic-search/elastic-serch.service';
import { WizardIdEnum } from '@app/core/model/enum/wizard-id.enum';
import { animate, style, transition, trigger } from '@angular/animations';
import { WizardManagerService } from '@app/core/service/wizards/wizard-manager.service';
import { UserWizardApiService } from '@app/core/service/wizards/user-wizard-api.service';
interface WizardMenuItem {
  id: WizardIdEnum;
  label: string;
  description: string;
  hasBeenSeen: boolean;
}

@UntilDestroy()
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('slideDown', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-10px)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('150ms ease-in', style({ opacity: 0, transform: 'translateY(-10px)' }))
      ])
    ])
  ]
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild('mobileMenu')
  mobileMenu: ElementRef;

  public customerCode: string;
  public businessInformationToDisplay: string;
  public userLogin: string
  public activeLanguage: BehaviorSubject<string>;
  public languages = environment.languages;

  public useTestElkConfig = false;


  public logoPath: string = environment.defaultLogoUrl;
  public defaultLogoPath: string = environment.defaultLogoUrl;
  public searchTerm: string;

  public showSideMenu = false;
  public context: Context = null;
  public fullContext: FullContext = null;
  public contextOrder: Order;
  public contextFranco: Franco;
  public user: User;
  public orderStatusEnum = OrderStatus;
  public validityRate$ = new BehaviorSubject(0);
  public remainingTime$ = new BehaviorSubject('');
  public adresseLivraison: string = "Selectionnez une commande";

  public businessContact: BusinessContact;

  // Liste des sociétés disponibles
  public availableCompanies$: Observable<Company[]>;
  public availableCompanies: Company[];
  public firstDeliveryDateNOR: string = 'Pas de Dates';
  public firstDeliveryDateSUR: string = 'Pas de Dates';
  public favoriteCount: number;

  public showWizardMenu = false;
  public availableWizards: WizardMenuItem[] = [];
  private isTogglingWizard = false;

  constructor(public contextService: ContextService, public authenticationService: AuthenticationService,
    private translationService: TranslationService, private router: Router,
    private orderService: OrderService, private contactService: ContactService,
    private modalFactory: ModalFactoryService, private toastrService: ToastrService,
    private wizardManager: WizardManagerService, private userService: UserService,
    public translateService: TranslateService,
    public searchService: SearchService, public customerService: CustomerService,
    private elasticSearchService: ElasticSearchService,
    private companyService: CompanyService, public favoriteService: FavoriteService,
    private sortingService: SortingService, private francoService: FrancoService,
    private dialogService: DialogService, private offerStateService: OfferStateService,
    private userWizardApiService: UserWizardApiService) {
    // Close mobile menu on url change
    router.events.subscribe(events => {
      this.showSideMenu = false;
    });
  }

  /**
   * Initialisation du composant
   */
  async ngOnInit() {
    this.userService.getUser$().subscribe(user => {
    this.userLogin = user?.code;
    });

    this.elasticSearchService.getUseTestElkConfig$().subscribe(x => this.useTestElkConfig = x);
    this.contextService.context$.subscribe((context) => this.context = context);

    this.companyService.getAvailableCompanies$().subscribe(companies => {
      if (companies) {
        this.availableCompanies = companies;
      }
    });
    this.activeLanguage = this.translationService.getActiveLanguage();

    this.contextService.fullContext$
      .pipe(untilDestroyed(this))
      .subscribe(async fullContext => {
        if (fullContext?.customer) {
          this.businessInformationToDisplay = fullContext.customer.code + ' - ' + fullContext.customer.businessName; 
        }
        this.fullContext = fullContext;
        if (fullContext.company && fullContext.company.picture) {
          this.logoPath = environment.baseFileUrl + fullContext.company.picture.url;
        }
        else {
          this.logoPath = this.defaultLogoPath;
        }

        this.contextOrder = fullContext.order;

        if (this.contextOrder) {
          await this.setAdresseLivraison();
        }
        else {
          this.adresseLivraison = "Selectionnez une commande";
        }

        // Force la valeur du franco pour Vitafrais
        // FrancoUnique.01
        if (fullContext.company?.code === 'VITAFRAIS' && this.contextOrder) {
          if (fullContext.franco !== null && fullContext.franco !== undefined && fullContext.customer.isFrancoUnique) {
            this.contextOrder.price.seuilFranco = 390;
          }
          else if (this.contextOrder.price?.seuilFranco == 0)
            this.contextOrder.price.seuilFranco = 390;
        }

        // Force la valeur du franco pour PRONATURAFRANCE
        // FrancoUnique.01
        if (fullContext.company?.code === 'PRONATURAFRANCE' && this.contextOrder) {
          if (fullContext.franco !== null && fullContext.franco !== undefined && fullContext.customer.isFrancoUnique) {
            this.contextOrder.price.seuilFranco = 450;
          }
          else if (this.contextOrder.price?.seuilFranco == 0)
            this.contextOrder.price.seuilFranco = 450;
        }

        if (fullContext.company && fullContext.customer && fullContext.company.code === 'VITAFRAIS') {
          var date2 = new Date();
          date2.setDate(date2.getDate() + 2);
          this.firstDeliveryDateNOR = date2.toLocaleDateString();
          var deliveryDatesNOR =
            this.customerService.getDeliveryDates(fullContext.company.code, fullContext.customer.code, fullContext.customer.deliveryAddresses[0]?.code, 'NOR');
          deliveryDatesNOR.subscribe(dates => {
            if (dates.length > 0) {
              this.firstDeliveryDateNOR = new Date(dates[0].deliveryDate).toLocaleDateString();
            }
          }
          );
        }
        this.businessContact = fullContext.customer?.businessContacts?.find(bc => bc.email == fullContext.customer?.defaultBusinessContactMail);
        this.contextOrder = fullContext.order;

      });

    this.searchTerm = this.searchService.term;


    // TODO
    /* this.contextService.fullContext$.subscribe(context => {
      this.contextOrder = context.order;
      if (this.contextOrder) {
        this.updateOrderValidity();
      }
    }); */

    interval(1000)
      .pipe(
        // Unsubscribe when component is destroyed or when order status isn't CREATED anymore
        untilDestroyed(this),
        takeWhile(
          () =>
            this.contextOrder &&
            this.contextOrder.validityEndDate &&
            this.contextOrder.validityStartDate &&
            this.contextOrder.status === OrderStatus.CREATED
        ),
        // Subscribe again if context has changed => order status could be CREATED again
        repeatWhen(() => this.contextService.fullContext$)
      )
      .subscribe(tick => {
        if (this.contextOrder) {
          this.updateOrderValidity();
        }
      });

    // Récupération du nombre de favoris
    this.favoriteService.favoris$.subscribe((count) => {
      this.favoriteCount = count;
      //if (this.favoriteCount == 0)
      //this.favoriteService.getCountFavorites();
    });

    this.loadAvailableWizards();

  }


  /**
   * Destruction du composant
   */
  ngOnDestroy(): void { }

  /**
   * Set the delivery address to display
   */
  public setAdresseLivraison() {
    if (this.fullContext.order != null) {
      this.adresseLivraison = this.contextOrder?.deliveryAddress?.address1 + ", "
        + this.contextOrder?.deliveryAddress?.address2 + ", "
        + this.contextOrder?.deliveryAddress?.address3 + " "
        + this.contextOrder?.deliveryAddress?.zipCode + " "
        + this.contextOrder?.deliveryAddress?.city;
    }
  }

  /**
   * Set new language to use for the translation
   */
  public languageEmitted(language: string): void {
    this.translationService.setActiveLanguage(language);
    this.activeLanguage = this.translationService.getActiveLanguage();
    location.reload();
  }

  public onClickOutside(): void {
    if (this.showSideMenu) {
      this.toggleSideMenu();
    }
  }

  public toggleSideMenu(): void {
    this.showSideMenu = !this.showSideMenu;
  }



  /**
   * Check order validity and update the time remaining (and as a percentage between 0 and 1)
   */
  public async updateOrderValidity() {
    // Corriger les dates mal encodées en UTC mais qui sont censées être en Europe/Paris
    const rawEnd = moment.parseZone(this.contextOrder.validityEndDate);
    const validityEndDate = moment.utc({
      year: rawEnd.year(),
      month: rawEnd.month(),
      day: rawEnd.date(),
      hour: rawEnd.hour(),
      minute: rawEnd.minute(),
      second: rawEnd.second(),
    }).tz('Europe/Paris');

    const rawStart = moment.parseZone(this.contextOrder.validityStartDate);
    const validityStartDate = moment.utc({
      year: rawStart.year(),
      month: rawStart.month(),
      day: rawStart.date(),
      hour: rawStart.hour(),
      minute: rawStart.minute(),
      second: rawStart.second(),
    }).tz('Europe/Paris');

    const currentDate = moment.tz('Europe/Paris') // Heure actuelle locale

    const remainingTime = validityEndDate.diff(currentDate);

    const maxTime = moment(validityEndDate).diff(
      moment(validityStartDate)
    );

    const validityRate = remainingTime / maxTime;

    if (validityRate < 0) {
      this.contextOrder.status = OrderStatus.INACTIVE;
      this.contextService.setSelectedFullOrder(this.contextOrder);
    }

    this.validityRate$.next(validityRate);

    const duration = moment.duration(remainingTime);
    const hours = Math.floor(duration.asHours());
    const minutes = Math.abs(duration.minutes());
    const seconds = Math.abs(duration.seconds());

    let time: string;
    if (hours >= 24) {
      time = Math.ceil(hours / 24) + ' ' + this.translateService.instant('time.days');
    } else {
      time = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }

    this.remainingTime$.next(time);
  }

  public reactivateOrder(): void {
    this.modalFactory.confirm(
      () => {
        this.orderService
          .postReactivate(
            this.context.companyCode,
            this.context.customerCode,
            this.context.orderCode
          )
          .subscribe(
            success => {
              // Update order status
              this.contextService.setSelectedOrder(
                this.context.orderCode
              );
              this.toastrService.success(
                this.translateService.instant('order.reactivateOrderSuccess')
              );
            },
            error => { }
          );
      },
      () => { },
      this.translateService.instant('modal.reactivateOrderTitle')
    );
  }

  public callbackRequest(): void {
    this.contactService
      .postCallbackRequest(
        this.context.companyCode,
        this.context.contactCode,
        this.context.customerCode
      )
      .subscribe(success => {
        this.toastrService.success(
          this.translateService.instant('contact.callbackRequestValid')
        );
      });

    this.toggleSideMenu();
  }

  public handleSearchClick(term: string) {
    if (term && term.length !== 0) {
      this.router.navigate(['/offers', 'search', term]);
    }
    this.offerStateService.setMode(this.fullContext.company?.settings?.offerDefaultView);
  }

  public keyup(event): void {
    if (event && event.key === 'Enter') {
      this.handleSearchClick(this.searchService.term);
    }
  }

  public startScan(): void {
    window.location.href = '/scan';
  }

  // Calcul le pourcentage d'atteinte du franco
  public calculatePercentage(): number {
    if (this.contextOrder && this.contextOrder.price?.seuilFranco && this.contextOrder.price?.seuilFranco > 0 && this.contextOrder.price?.total) {
      const totalPrice = parseFloat(this.contextOrder.price.total);
      const percent = Math.round((totalPrice / this.contextOrder.price.seuilFranco) * 100);
      return percent < 100 ? percent : 100;
    }
    return 0;
  }

  // Changement de société
  public onCompanySelected(companyCode: string) {
    this.contextService.setSelectedCompany(companyCode);
    this.sortingService.clearSort();
  }

  // Permet de créer une nouvelle commande
  newOrder() {
    this.modalFactory.newOrder((order: Order) => {
      if (!order.orderType && this.fullContext.customer.orderTypes && this.fullContext.customer.orderTypes.length == 1)
        order.orderType = this.fullContext.customer.orderTypes[0].code;

      this.orderService.postNewOrder(this.context.companyCode,
        this.context.customerCode,
        order.customCode,
        order.deliveryAddress.code,
        order.deliveryDate,
        order.headerComment,
        order.orderType)
        .subscribe((o: Order) => {
          this.contextService.setSelectedFullOrder(o);
          this.router.navigateByUrl('/offers');
        });
    });
  }

  public setCompany(companyCode: string) {
    this.contextFranco = null;
    this.contextService.setSelectedCompany(companyCode);
  }

  openDialogFranco() {
    if (!this.fullContext?.customer?.isFrancoUnique)
      return;
    var dialogFrancoData = new DialogFrancoData();
    dialogFrancoData.title = 'Franco';
    dialogFrancoData.content = 'Contenu du franco';
    dialogFrancoData.contextFranco = this.contextFranco;
    this.dialogService.openDialogGenerique(DialogFrancoComponent, dialogFrancoData, '70%');
  }

  // ---------------------------------------------------- Partie wizard ----------------------------------------------------//





  /**
  * Toggle l'affichage du menu wizard
  */
  toggleWizardMenu(event: Event): void {
    event.stopPropagation();
    this.showWizardMenu = !this.showWizardMenu;

    if (this.showWizardMenu) {
      this.loadAvailableWizards();
    }
  }

  /**
   * Ferme le menu wizard
   */
  closeWizardMenu(): void {
    this.showWizardMenu = false;
  }

  /**
   * Charge la liste des wizards disponibles avec leurs labels
   */
  private loadAvailableWizards(): void {
    const wizards = this.wizardManager.listWizards();

    // Mapper les IDs vers des labels et descriptions lisibles
    this.availableWizards = wizards.map(wizard => ({
      id: wizard.id,
      label: this.wizardManager.getWizard(wizard.id).getLabel(),
      description: this.wizardManager.getWizard(wizard.id).getDescription(),
      hasBeenSeen: wizard.hasBeenSeen
    }));
  }

}
